import { useQuery } from 'react-query';
import { ProgramProfile } from '@oh-vcp/components-common';
import { AxiosError } from 'axios';
import apiService from './apiService';

const fetchPrograms = async (programId: number): Promise<ProgramProfile> => {
  const url = `programs/${programId}`;
  const response = await apiService.get(url);
  return response.data;
};

const useProgramLookup = (programId: number | undefined | null) => {
  return useQuery<ProgramProfile, AxiosError>(
    ['programLookup', programId],
    () => fetchPrograms(programId!),
    {
      enabled: !!programId,
      refetchOnWindowFocus: false,
      retry: false
    }
  );
};

export default useProgramLookup;
